import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import Logo from './imgs/logo.png';

const Header = ({ text }) => {
    return (
        <div className='header-main'>
            <div className='container'>
                <div className='header-main-wrapper'>
                    <div className='logo'>
                    
                       <a href='https://www.dw4t.be' target='_blank' rel="noreferrer"> <img src={Logo} alt='Logo'></img></a>
                    </div>
                    <div className='header-info'>
                        <p>{text}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
